import { Suspense, useState } from "react";
import { Modal } from "react-bootstrap";
import { Outlet } from "react-router-dom";
import { I18nProvider } from "../_metronic/i18n/i18nProvider";
import { LayoutProvider, LayoutSplashScreen } from "../_metronic/layout/core";
import { MasterInit } from "../_metronic/layout/MasterInit";
import { ThemeModeProvider } from "../_metronic/partials";
import { AuthInit, useAuth } from "./modules/auth";
import "leaflet/dist/leaflet.css";

declare global {
	interface Window {
		devToolsBlocked?: boolean;
	}
}

const App = () => {
	const [showModal, _setShowModal] = useState(false);
	const [accessDenied, _setAccessDenied] = useState(false);
	const [_devToolsAllowed, _setDevToolsAllowed] = useState(false);
	const { logout } = useAuth();

	// useEffect(() => {
	//   if (import.meta.env.VITE_ENV === "development") {
	//     return;
	//   }
	//   const disableContextMenu = (e: MouseEvent) => e.preventDefault();
	//   document.addEventListener("contextmenu", disableContextMenu);

	//   const disableShortcuts = (e: KeyboardEvent) => {
	//     if (
	//       e.key === "F12" ||
	//       (e.ctrlKey && e.shiftKey && ["I", "J", "C"].includes(e.key.toUpperCase())) ||
	//       (e.ctrlKey && e.key.toUpperCase() === "U")
	//     ) {
	//       e.preventDefault();
	//     }
	//   };
	//   document.addEventListener("keydown", disableShortcuts);

	//   const handleDevToolsOpen = () => {

	//     if (window.devToolsBlocked || devToolsAllowed) return;
	//     window.devToolsBlocked = true;
	//     logout();
	//     setAccessDenied(true);
	//     setShowModal(true);
	//   };

	//   // Smarter detection – no resize false positive
	//   const detectDevTools = () => {
	//     if (devtools.isOpen) {
	//       handleDevToolsOpen();
	//       return;
	//     }

	//     // Console profile trick (detects any open)
	//     const start = performance.now();
	//     console.profile();
	//     console.profileEnd();
	//     const duration = performance.now() - start;
	//     if (duration > 50) {
	//       handleDevToolsOpen();
	//     }
	//   };

	//   const interval = setInterval(detectDevTools, 1200);

	//   return () => {
	//     clearInterval(interval);
	//     document.removeEventListener("contextmenu", disableContextMenu);
	//     document.removeEventListener("keydown", disableShortcuts);
	//   };
	// }, [logout, devToolsAllowed]);

	return (
		<>
			{accessDenied && (
				<div
					style={{
						display: "flex",
						height: "100vh",
						alignItems: "center",
						justifyContent: "center",
						backgroundColor: "#000",
						color: "red",
						fontSize: "2rem",
						fontWeight: "bold",
						position: "fixed",
						top: 0,
						left: 0,
						width: "100%",
						zIndex: 1040,
					}}
				>
					Access Denied
				</div>
			)}

			<Modal show={showModal} centered backdrop="static" keyboard={false}>
				<Modal.Header style={{ background: "#ff4d4d", color: "white" }}>
					<Modal.Title> Access Blocked</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<p className="mb-3">
						Developer Tools have been detected. For security reasons, your
						session has been terminated.
					</p>
					<p>Please close Developer Tools and refresh the page to continue.</p>
				</Modal.Body>
			</Modal>

			{!accessDenied && (
				<Suspense fallback={<LayoutSplashScreen />}>
					<I18nProvider>
						<LayoutProvider>
							<ThemeModeProvider>
								<AuthInit>
									<Outlet />
									<MasterInit />
								</AuthInit>
							</ThemeModeProvider>
						</LayoutProvider>
					</I18nProvider>
				</Suspense>
			)}
		</>
	);
};

export { App };
